import { render, staticRenderFns } from "./provider-form.vue?vue&type=template&id=2a2218e8"
import script from "./provider-form.vue?vue&type=script&lang=js"
export * from "./provider-form.vue?vue&type=script&lang=js"
import style0 from "./provider-form.vue?vue&type=style&index=0&id=2a2218e8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports